import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import { getWatchlist } from "@/lib/api";
import { MovieCard } from "@/components/MovieCard";
import { PageToolbar, usePageTranslation } from "@/components/PageToolbar";

const INTRO = { title: "Watchlist", sub: "Your personal cinema, saved on this device and synced to your account when signed in." };

export default function Watchlist() {
  const [list, setList] = useState(getWatchlist());

  useEffect(() => {
    const h = () => setList(getWatchlist());
    window.addEventListener("watchlist-changed", h);
    return () => window.removeEventListener("watchlist-changed", h);
  }, []);

  const blocks = useMemo(() => INTRO, []);
  const { lang, tr, busy } = usePageTranslation(blocks, "watchlist-intro");

  return (
    <main data-testid="watchlist-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <p className="eyebrow">Your Personal Cinema</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl mt-2 text-[#1c1512]">{tr("title", INTRO.title)}</h1>
      <p className="text-[#6b5d51] mt-3">{tr("sub", INTRO.sub)} {list.length} film{list.length === 1 ? "" : "s"}.</p>
      <div className="mt-4">
        <PageToolbar speakText={`${tr("title", INTRO.title)}. ${tr("sub", INTRO.sub)} ${list.map((m) => m.title).join(", ")}`} busy={busy} lang={lang} />
      </div>

      {list.length === 0 ? (
        <div data-testid="watchlist-empty-state" className="text-center py-24">
          <Bookmark className="w-10 h-10 text-[#d8ccb8] mx-auto" />
          <p className="font-display text-2xl text-[#6b5d51] mt-4">Your watchlist is empty.</p>
          <Link to="/explore" data-testid="watchlist-explore-link" className="inline-block mt-6 bg-[#7d1a1a] text-[#f6f1e7] px-6 py-3 font-medium hover:bg-[#5c1220] transition-colors">
            Explore Global Cinema →
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-8">
          {list.map((m) => <MovieCard key={m.id} movie={m} />)}
        </div>
      )}
    </main>
  );
}
